import { type IMesh, type IMeshGeometry, MeshParser } from '@seddi/mesh';
import type { VertexDataDesc } from '../domain/bufferTypes';
import type { MeshDesc } from './meshTypes';

/**
 * Adapt mesh.
 * @param src - Mesh.
 */
export const adapt = (src: IMesh): MeshDesc => {
  const geometry = adaptGeometry(src.geometry);
  return { id: src.id, geometry };
};

/**
 * Adapt mesh geometry.
 * @param src - Mesh geometry.
 */
export const adaptGeometry = (src: IMeshGeometry): VertexDataDesc => {
  return { indices: src.indices, positions: src.position!, normals: src.normal, uvs: src.uv_0 };
};

/**
 * Fetch mesh geometry file URL and parse.
 * @param url - Geometry file URL.
 */
export const fetchGeometry = async (url: string): Promise<IMeshGeometry> => {
  const response = await fetch(url);
  const buffer = await response.arrayBuffer();
  const mesh = MeshParser.Parse(buffer);
  return mesh.geometry;
};
